<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <el-input
            v-model="advertisersQuery.sub_uc_id"
            class="inptw"
            placeholder="请输入子账号id"
          />
          <el-input
            v-model="advertisersQuery.user_id"
            class="inptw"
            placeholder="请输入主账号id"
          />
          <el-input
            v-model="advertisersQuery.videoid"
            class="inptw"
            placeholder="请输入创意id"
          />
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>
        <el-button
          class="filter-item"
          type="danger"
          @click="deleteAll"
        >批量删除</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        fit
        style="width: 100%; justify-content: space-between;"
      >
        <el-table-column
          prop="videoid"
          label="视频id"
          align="center"
          width="130px"
        >
          <template slot-scope="scope">
            <el-checkbox
              @change="handleCheckChange(scope.row)"
            >{{ scope.row.videoid }}</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          prop="preview_url"
          label="视频文件预览地址"
          align="center"
        >
          <template scope="scope">
            <!-- -->
            <video
              width="150"
              height="150"
              controls
              muted
              :src="scope.row.url"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="key_frame_image_url"
          label="视频首帧缩略图地址"
          align="center"
        >
          <template scope="scope">
            <el-image
              style="width: 90px; height: 90px"
              :src="scope.row.thumbnail"
              fit="cover"
              :preview-src-list="[scope.row.thumbnail]"
              @click.stop="handleClickStop"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="videoName"
          label="视频名称"
          align="center"
        />
        <el-table-column
          label="图片宽度(px)/图片高度(px)"
          align="center"
          width="180"
        >
          <template scope="scope">
            {{ scope.row.width }}x{{ scope.row.height }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sub_uc_name"
          label="子账号名称"
          align="center"
          width="130px"
        />
        <el-table-column
          prop="sub_uc_id"
          label="子账号userid"
          align="center"
        />
        <el-table-column
          prop="capacity"
          label="视频大小"
          align="center"
        />
        <el-table-column
          prop="fromUserId"
          label="来源账号"
          align="center"
        />
        <el-table-column
          prop="addTimeText"
          label="添加时间"
          align="center"
          width="130px"
        />
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="150px"
        >
          <template scope="scope">
            <el-button slot="reference" type="danger" size="mini" @click="deleteVideoById(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      title="确定删除"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-tag
        v-for="item in deleteItems"
        :key="item.videoName"
        closable
        type="success"
        style="margin-left: 5px"
        @close="handleClose(item)"
      >
        {{ item.videoName }}
      </el-tag>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="deleteVideo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import PaginationRight from '@/components/PaginationRight/index.vue'
import { delVideo, video_list } from '@/api/baiduAD'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        page: 1,
        page_size: 10,
        videoid: null,
        user_id: null,
        sub_uc_id: null
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      dialogVisible: false,
      accountIdsQuery: [],
      loading: false,
      deleteItems: []
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    getAdvertiserList() {
      this.loading = true
      video_list(this.advertisersQuery).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.advertisersQuery.page_size = 10
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {
        account_id: null,
        status: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      }
      this.getAdvertiserList()
    },
    handleCheckChange(val) {
      this.deleteItems.push(val)
    },
    deleteAll() {
      if (this.deleteItems.length === 0) {
        this.$message.error('当前未选中视频')
        return
      }
      this.dialogVisible = true
    },
    deleteVideo() {
      delVideo({
        videoids: this.deleteItems.map(res => res.videoid)
      }).then(res => {
        this.$message.success('发送请求成功')
        this.deleteItems.length = 0
        this.dialogVisible = false
      })
    },
    deleteVideoById(val) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delVideo({ videoids: [val.videoid] }).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$message.success('发送请求成功')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleClose(item) {
      this.deleteItems = this.deleteItems.filter(i => i.videoName !== item.videoName)
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 10px;
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.inptw {
  width: 250px;
  margin-right: 10px;
}
</style>
